import * as React from "react";
const SvgExport20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 18,
        viewBox: "0 0 20 18",
        fill: "black"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v18h12v-6h-2v4H2V2h8v4h2V0H1Zm14.207 4.293-.707-.707L13.086 5l.707.707L16.086 8H6.5v2h9.586l-2.293 2.293-.707.707 1.414 1.414.707-.707 4-4L19.914 9l-.707-.707-4-4Z",
      clipRule: "evenodd"
    })
  );
export default SvgExport20Px;
